<template>
  <b-form :data-vv-scope="$_getScope()" @submit.prevent class="custom-domains">
    <b-form-group class="optimizer-form-group">
      <template slot="label">
        Headers (optional) <i class="fa fa-info-circle" aria-hidden="true" v-b-tooltip="{hover: true, top: true, title: 'If you are using Authorization or other Headers, please enter them below.', boundary: 'window'}"></i>
      </template>
      <div v-for="(row, i) in headers" :key="i">
        <!--Header Input-->
        <b-form-group
          :state="$_hasError('header-' + i)"
          :invalid-feedback="$_getError('header-' + i)"
        >
          <!--Name-->
          <b-input-group>
            <b-form-input
              class="optimizer-form-input grey"
              data-vv-as="Header"
              validate="required"
              v-model="row.name"
              :name="'header-' + i"
            >
            </b-form-input>
            <!--Value -->
            <b-form-input
              class="optimizer-form-input"
              data-vv-as="Header"
              validate="required"
              v-model="row.value"
              :name="'value-' + i"
            >
            </b-form-input>
            <template slot="append">
              <button @click.prevent="$_removeAction(i)" class="btn btn-secondary text-danger"><i class="fa fa-minus"></i></button>
            </template>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="add-domain-btn">
        <b-btn class="primary-button-outline" @click.prevent="$_addAction"><i class="fa fa-plus"></i> Add Header</b-btn>
      </div>
    </b-form-group>
  </b-form>
</template>

<script>
export default {
  name: 'Headers',
  props: {
    value: null,
    limit: { type: Number, default: 10 },
  },
  data() {
    return {
      headers: [], // { name: 'Authorization', value: '' }
    };
  },
  watch: {
    headers: {
      handler(headers) {
        this.$emit('input', headers);
      },
      deep: true,
    },
  },
  created() {
    if (Array.isArray(this.value)) {
      const headers = [];
      this.value.forEach((item) => {
        headers.push({ name: item.name, value: item.value });
      });
      if (headers.length > 0) this.headers = headers;
    }
  },
  methods: {
    async validate() {
      return this.$validator.validateAll(this.$_getScope());
    },
    reset() {
      this.headers = [];
    },
    async $_addAction() {
      if (await this.validate() && this.headers.filter((item) => item.name === '' || item.value === '').length === 0 && this.headers.length < this.limit) {
        this.headers.push({ name: '', value: '' });
      }
    },
    $_removeAction(index) {
      this.headers.splice(index, 1);
    },
    $_getScope() {
      return 'headers';
    },
    $_hasError(name) {
      return this.$validator.errors.has(`${this.$_getScope()}.${name}`) ? false : null;
    },
    $_getError(name) {
      return this.$validator.errors.first(`${this.$_getScope()}.${name}`);
    },
    $_removeError(name) {
      this.$validator.errors.remove(name, this.$_getScope());
    },
  },
};
</script>

<style lang="scss">
.custom-domains {
  margin-top: 2rem;

  .optimizer-form-input.grey {
    background: #F4F9FC;
  }

  .input-group {
    &-prepend,
    &-append {
      height: 3.7rem;
      background: #F4F9FC;
      border: .1rem solid $color-light-gray;
      border-radius: .6rem;
      display: flex;
      align-items: center;
      color: $black-600;
      font-size: 1.4rem;

      .input-group-text {
        font-size: 1.4rem;
        color: $black-600;
        background: transparent;
        border: none;
      }

      .btn-secondary {
        height: 3.7rem;
        display: flex;
        align-items: center;
        background: transparent;
        border: none;
        border-left: .1rem solid $color-light-gray;
        padding: 1.5rem;

        &:focus,
        &:active {
          background: transparent;
          border-color: $color-light-gray;
        }

        i {
          font-size: 1.6rem;
          padding: 0;
        }
      }
    }

    &-prepend {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &-append {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    .form-control {
      border-right: 0 !important;
    }
  }

  .add-domain-btn {
    .primary-button-outline {
      font-size: 1.3rem;
      padding: .5rem .8rem;

      &:hover {
        border-color: #2196F3;
      }
    }
  }
}
</style>
